<template>
  <ProductPageLayout
    name="DeskClock"
    :logo="logo"
    :hero-image="heroImage"
    lead="Transparent flip and illustration clocks for your desktop — click-through widgets, calendar display, and full-screen screensaver mode."
    :feature-lines="featureLines"
    download-link="/ftp/packages/deskclock/DeskClockSetup.exe"
    download-file-name="DeskClockSetup.exe"
    :meta-items="metaItems"
    :detailed-features="detailedFeatures"
    :other-features="otherFeatures"
    :reviews="reviews"
    features-desc="Themes and desktop widgets so time looks good and stays useful."
    other-desc="More styles and display modes for different desktop setups."
    reviews-desc="Real feedback that keeps improving DeskClock."
  />
</template>

<script>
import ProductPageLayout from '@/components/ProductPageLayout.vue'

export default {
  name: 'DeskClock',
  components: { ProductPageLayout },
  data() {
    return {
      logo: require('@/assets/deskclock/deskclock_48x48.png'),
      heroImage: require('@/assets/deskclock/时钟中心.png'),
      featureLines: [
        'Flip clock / minimal digits / analog dial / illustration themes',
        'Desktop widget / custom clock / full-screen screensaver / calendar'
      ],
      metaItems: [
        { icon: 'shield', label: 'Safe to install' },
        { icon: 'plugin-free', label: 'No junk plugins' },
        { icon: 'ad-free', label: 'No ads' }
      ],
      detailedFeatures: [
        {
          title: 'Theme center',
          brief: 'Browse and switch polished themes until you find the right look.',
          detail: 'Flip, digital, analog, and illustration themes are organized clearly. Preview then apply to the desktop in one click.',
          image: require('@/assets/deskclock/时钟中心.png')
        },
        {
          title: 'Desktop widget',
          brief: 'A floating clock that stays on the desktop with transparent click-through.',
          detail: 'Resize and opacity controls, always-on-top, and click-through so icons remain usable. Remembers position across monitors.',
          image: require('@/assets/deskclock/桌面挂件.png')
        },
        {
          title: 'Flip clock themes',
          brief: 'Classic flip animation that stays readable from across the room.',
          detail: 'Large flip digits suit a second monitor or distance viewing — time changes are obvious and the desktop feels intentional.',
          image: require('@/assets/deskclock/主题库-翻页.png')
        },
        {
          title: 'Illustration themes',
          brief: 'Illustrated dials that add warmth without losing readability.',
          detail: 'Curated illustration themes and optional particle effects keep the clock clear while adding depth to your wallpaper.',
          image: require('@/assets/deskclock/主题库-插画.png')
        }
      ],
      otherFeatures: [
        { title: 'Minimal digits', description: 'Clean digital face with high transparency that blends into wallpaper.', iconImage: require('@/assets/deskclock/主题库-数字.png') },
        { title: 'Analog dial', description: 'Classic hands with adjustable dial details for traditional reading habits.', iconImage: require('@/assets/deskclock/主题库-指针.png') },
        { title: 'Full-screen screensaver', description: 'One-click full-screen clock for classrooms, idle displays, or a second monitor.', iconImage: require('@/assets/deskclock/全屏屏保.png') },
        { title: 'Custom clock', description: 'Use your own photo as the clock background for a personal widget.', iconImage: require('@/assets/deskclock/自定义时钟.png') }
      ],
      reviews: [
        { name: 'Maya', comment: 'The flip clock looks great and click-through never blocks my desktop icons.', avatar: require('@/assets/deskclock/avatar1.jpg') },
        { name: 'Noah', comment: 'I keep a large flip clock on my second screen while editing — theme switching is fast.', avatar: require('@/assets/deskclock/avatar2.jpg') },
        { name: 'Ava', comment: 'Illustration themes set the mood; calendar and weekday display match my wallpaper nicely.', avatar: require('@/assets/deskclock/avatar3.jpg') },
        { name: 'Liam', comment: 'Full-screen screensaver works as a classroom clock. Clean UI, small installer.', avatar: require('@/assets/deskclock/avatar4.jpeg') },
        { name: 'Emma', comment: 'Custom photo clocks impress clients during demos — the desktop looks intentional instantly.', avatar: require('@/assets/deskclock/avatar5.jpeg') },
        { name: 'Owen', comment: 'Analog and digital themes cover my needs. Always-on-top and click-through stay stable all day.', avatar: require('@/assets/deskclock/avatar6.jpeg') }
      ]
    }
  }
}
</script>
